export const tradeScreeningTransformation = {
  id: 'masterDataManagementPortal',
  name: _TL_('Management portal'),
  route: 'MasterData/ManagementPortal',
  checkPermission: permissions => permissions.dynamic.WebpackifyPhase2Customer,
};
